import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';
import {getPartPrice} from '../../common/util/partsUtils';
import {filterObjectsArrayByValue} from '../../common/util/array';

const COMPANY_CODE = 'TE';

const INITIAL_STATE = {
  'loading': false,
  'verifying': false,
  'loadingImage': false,
  'loadingFactors': false,
  'loadingRejection': false,
  'loadingEquivalences': false,
  'loadingSubstitutes': false,
  'loadingComposed': false,
  'loadingCompatibility': false,
  'loadingPartCarModels': false,
  'loadingPartGreyCarModels': false,
  'loadingFranchisees': false,
  'loadingFranchise': false,
  'loadingpartSScc': false,
  'loadingAttachments': false,
  'rawAttachments': [],
  'attachments': [],
  'partsScc': [],
  'franchisees': [],
  'equivalences': [],
  'wasSearched': false,
  'previous': [],
  'substitutes': [],
  'composed': [],
  'compatibility': [],
  'partCarModels': [],
  'partGreyCarModels': [],
  'lastModelSaved': null,
  'factors': null,
  'pncLink': null,
  'unregisteredSubstitute': '',
  'rejectionCode': '',
  'wasSaved': false,
  'openConfirmation': false,
  'confirmationMessages': [],
  'previousPvpPrice': null,
  'previousTdePrice': null,
  'isValidPart': false,
  'allowFOBEdition': false,
  'values': {
    'isGrey': false,
    'isInen': false,
    'isHighValue': false,
    'discontinued': false,
    'enabled': true,
    'allowSupplierOrders': true,
    'allowDealersOrders': true,
    'allowPriceChange': true,
    'applyTaxes': true,
    'image': '',
    'productDescription': '',
    'madeIn': '',
    'partClass': 'R',
    'franchise': 'A',
    'partCode': '',
    'partName': '',
    'supplier': '',
    'origin': '',
    'productCode': '',
    'pncDescription': '',
    'pnc': '',
    'icc': 'F',
    'scc': '',
    'fob': 0.0,
    'priceTde': 0.0,
    'pricePvp': 0.0,
    'priceFactors': 0.0,
    'cost': 0.0,
    'incomingPart': '',
    'company': null,
    'haveFiles': 'N',
    'gallon': 0,
  },
};

const updatePartPrices = (values, factors) => {
  const {fob, 'priceFactors': factorIndex, company} = values;

  if (!company) {
    const pricePvp = getPartPrice(fob, {factors, factorIndex}, true);
    const priceTde = getPartPrice(fob, {factors, factorIndex}, false);

    return {...values, pricePvp, priceTde};
  }

  return values;
};

export const partsMaster = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.GET_PART_MASTER_INFO_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.GET_PART_MASTER_INFO_SUCCESS]: (state, action) => {
      const haveFiles = action.response.data.haveFiles || 'N';

      return {
        ...state,
        'loading': false,
        'values': {...state.values, ...action.response.data, 'haveFiles': haveFiles},
        'previousPvpPrice': action.response.data.pricePvp,
        'previousTdePrice': action.response.data.priceTde,
        'allowFOBEdition': action.response.data.fob ? false : true,
        'wasSearched': action.response.data.partName ? true : false,
      };
    },
    [ActionTypes.GET_PART_MASTER_INFO_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.SAVE_PART_MASTER_INFO_REQUEST]: (state, action) => ({
      ...state,
      'pncLink': null,
      'loading': true,
    }),
    [ActionTypes.SAVE_PART_MASTER_INFO_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'wasSaved': true,
      'previousPvpPrice': state.values.pricePvp,
      'previousTdePrice': state.values.priceTde,
      'values': {...state.values, 'company': COMPANY_CODE},
    }),
    [ActionTypes.SAVE_PART_MASTER_INFO_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'pncLink': action.error.data.link,
    }),
    [ActionTypes.EDIT_PART_MASTER_INFO_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
      'pncLink': null,
    }),
    [ActionTypes.EDIT_PART_MASTER_INFO_SUCCESS]: (state, action) => ({
      ...state,
      'wasSaved': true,
      'loading': false,
      'previousPvpPrice': state.values.pricePvp,
      'previousTdePrice': state.values.priceTde,
    }),
    [ActionTypes.EDIT_PART_MASTER_INFO_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'pncLink': action.error.data.link,
    }),
    [ActionTypes.GET_PART_PRICE_FACTORS_REQUEST]: (state, action) => ({
      ...state,
      'loadingFactors': true,
    }),
    [ActionTypes.GET_PART_PRICE_FACTORS_SUCCESS]: (state, action) => ({
      ...state,
      'loadingFactors': false,
      'factors': action.response.data,
      'values': updatePartPrices(state.values, action.response.data),
    }),
    [ActionTypes.GET_PART_PRICE_FACTORS_FAILED]: (state, action) => ({
      ...state,
      'factors': null,
      'loadingFactors': false,
    }),
    [ActionTypes.GET_PRODUCT_CODE_PRICE_FACTORS_REQUEST]: (state, action) => ({
      ...state,
      'loadingFactors': true,
    }),
    [ActionTypes.GET_PRODUCT_CODE_PRICE_FACTORS_SUCCESS]: (state, action) => ({
      ...state,
      'loadingFactors': false,
      'factors': action.response.data,
      'values': updatePartPrices(state.values, action.response.data),
    }),
    [ActionTypes.GET_PRODUCT_CODE_PRICE_FACTORS_FAILED]: (state, action) => ({
      ...state,
      'factors': null,
      'loadingFactors': false,
    }),
    [ActionTypes.GET_PART_SUBSTITUTES_REQUEST]: (state, action) => ({
      ...state,
      'loadingSubstitutes': true,
    }),
    [ActionTypes.GET_PART_SUBSTITUTES_SUCCESS]: (state, action) => ({
      ...state,
      ...action.response.data,
      'loadingSubstitutes': false,
    }),
    [ActionTypes.GET_PART_SUBSTITUTES_FAILED]: (state, action) => ({
      ...state,
      'loadingSubstitutes': false,
    }),
    [ActionTypes.GET_PART_SPECIAL_SUBSTITUTES_REQUEST]: (state, action) => ({
      ...state,
      'loadingComposed': true,
    }),
    [ActionTypes.GET_PART_SPECIAL_SUBSTITUTES_SUCCESS]: (state, action) => ({
      ...state,
      'composed': action.response.data,
      'loadingComposed': false,
      'isValidPart': false,
    }),
    [ActionTypes.GET_PART_SPECIAL_SUBSTITUTES_FAILED]: (state, action) => ({
      ...state,
      'loadingComposed': false,
    }),
    [ActionTypes.GET_PART_EQUIVALENCES_REQUEST]: (state, action) => ({
      ...state,
      'loadingEquivalences': true,
    }),
    [ActionTypes.GET_PART_EQUIVALENCES_SUCCESS]: (state, action) => ({
      ...state,
      'equivalences': action.response.data,
      'loadingEquivalences': false,
    }),
    [ActionTypes.GET_PART_EQUIVALENCES_FAILED]: (state, action) => ({
      ...state,
      'loadingEquivalences': false,
    }),
    [ActionTypes.SAVE_PART_SUBSTITUTES_REQUEST]: (state, action) => ({
      ...state,
      'loadingSubstitutes': true,
    }),
    [ActionTypes.SAVE_PART_SUBSTITUTES_SUCCESS]: (state, action) => ({
      ...state,
      'substitutes': [...state.substitutes, action.response.data],
      'loadingSubstitutes': false,
      'values': {...state.values, 'allowDealersOrders': false},
    }),
    [ActionTypes.SAVE_PART_SUBSTITUTES_FAILED]: (state, action) => ({
      ...state,
      'loadingSubstitutes': false,
    }),
    [ActionTypes.SAVE_PART_SPECIAL_SUBSTITUTES_REQUEST]: (state, action) => ({
      ...state,
      'loadingComposed': true,
    }),
    [ActionTypes.SAVE_PART_SPECIAL_SUBSTITUTES_SUCCESS]: (state, action) => ({
      ...state,
      'composed': action.response.data,
      'loadingComposed': false,
    }),
    [ActionTypes.SAVE_PART_SPECIAL_SUBSTITUTES_FAILED]: (state, action) => ({
      ...state,
      'loadingComposed': false,
    }),
    [ActionTypes.SAVE_PART_EQUIVALENCES_REQUEST]: (state, action) => ({
      ...state,
      'loadingEquivalences': true,
    }),
    [ActionTypes.SAVE_PART_EQUIVALENCES_SUCCESS]: (state, action) => ({
      ...state,
      'equivalences': [...state.equivalences, action.response.data],
      'loadingEquivalences': false,
    }),
    [ActionTypes.SAVE_PART_EQUIVALENCES_FAILED]: (state, action) => ({
      ...state,
      'loadingEquivalences': false,
    }),
    [ActionTypes.DELETE_PART_SUBSTITUTE_REQUEST]: (state, action) => ({
      ...state,
      'loadingSubstitutes': true,
    }),
    [ActionTypes.DELETE_PART_SUBSTITUTE_SUCCESS]: (state, action) => ({
      ...state,
      'loadingSubstitutes': false,
      'substitutes': filterObjectsArrayByValue(
        state.substitutes,
        'code',
        action.payload
      ),
    }),
    [ActionTypes.DELETE_PART_SUBSTITUTE_FAILED]: (state, action) => ({
      ...state,
      'loadingSubstitutes': false,
    }),
    [ActionTypes.DELETE_PART_SPECIAL_SUBSTITUTE_REQUEST]: (state, action) => ({
      ...state,
      'loadingComposed': true,
    }),
    [ActionTypes.DELETE_PART_SPECIAL_SUBSTITUTE_SUCCESS]: (state, action) => ({
      ...state,
      'loadingComposed': false,
      'composed': [],
    }),
    [ActionTypes.DELETE_PART_SPECIAL_SUBSTITUTE_FAILED]: (state, action) => ({
      ...state,
      'loadingComposed': false,
    }),
    [ActionTypes.DELETE_PART_EQUIVALENCE_REQUEST]: (state, action) => ({
      ...state,
      'loadingEquivalences': true,
    }),
    [ActionTypes.DELETE_PART_EQUIVALENCE_SUCCESS]: (state, action) => ({
      ...state,
      'equivalences': filterObjectsArrayByValue(
        state.equivalences,
        'code',
        action.payload
      ),
      'loadingEquivalences': false,
    }),
    [ActionTypes.DELETE_PART_EQUIVALENCE_FAILED]: (state, action) => ({
      ...state,
      'loadingEquivalences': false,
    }),
    [ActionTypes.RESTORE_PARTS_MASTER_VALUES]: (state, action) => ({
      ...INITIAL_STATE,
      'lastModelSaved': state.lastModelSaved,
      'partGreyCarModels': state.partGreyCarModels,
      'partCarModels': state.partCarModels,
      'partsScc': state.partsScc,
      'values': {...INITIAL_STATE.values, 'partCode': state.values.incomingPart},
    }),
    [ActionTypes.CHANGE_PARTS_FORM_VALUE]: (state, action) => {
      if (action.payload.field === 'partCode') {
        return {
          ...state,
          'wasSearched': false,
          'values': {...state.values, [action.payload.field]: action.payload.value},
        };
      }

      return {
        ...state,
        'values': {...state.values, [action.payload.field]: action.payload.value},
      };
    },
    [ActionTypes.GET_PART_CAR_COMPATIBILITY_REQUEST]: (state, action) => ({
      ...state,
      'loadingCompatibility': true,
    }),
    [ActionTypes.GET_PART_CAR_COMPATIBILITY_SUCCESS]: (state, action) => ({
      ...state,
      'compatibility': action.response.data,
      'loadingCompatibility': false,
    }),
    [ActionTypes.GET_PART_CAR_COMPATIBILITY_FAILED]: (state, action) => ({
      ...state,
      'compatibility': [],
      'loadingCompatibility': false,
    }),
    [ActionTypes.SAVE_PART_CAR_COMPATIBILITY_REQUEST]: (state, action) => ({
      ...state,
      'loadingCompatibility': true,
    }),
    [ActionTypes.SAVE_PART_CAR_COMPATIBILITY_SUCCESS]: (state, action) => ({
      ...state,
      'compatibility': [...state.compatibility, action.response.data],
      'lastModelSaved': action.payload,
      'loadingCompatibility': false,
    }),
    [ActionTypes.SAVE_PART_CAR_COMPATIBILITY_FAILED]: (state, action) => ({
      ...state,
      'loadingCompatibility': false,
    }),
    [ActionTypes.DELETE_PART_CAR_COMPATIBILITY_REQUEST]: (state, action) => ({
      ...state,
      'loadingCompatibility': true,
    }),
    [ActionTypes.DELETE_PART_CAR_COMPATIBILITY_SUCCESS]: (state, action) => ({
      ...state,
      'compatibility': filterObjectsArrayByValue(
        state.compatibility,
        'lineNumber',
        action.payload
      ),
      'loadingCompatibility': false,
    }),
    [ActionTypes.DELETE_PART_CAR_COMPATIBILITY_FAILED]: (state, action) => ({
      ...state,
      'loadingCompatibility': false,
    }),
    [ActionTypes.GET_GREY_CAR_MODELS_REQUEST]: (state, action) => ({
      ...state,
      'loadingPartGreyCarModels': true,
    }),
    [ActionTypes.GET_GREY_CAR_MODELS_SUCCESS]: (state, action) => ({
      ...state,
      'partGreyCarModels': action.response.data,
      'loadingPartGreyCarModels': false,
    }),
    [ActionTypes.GET_GREY_CAR_MODELS_FAILED]: (state, action) => ({
      ...state,
      'partGreyCarModels': [],
      'loadingPartGreyCarModels': false,
    }),
    [ActionTypes.GET_PART_CAR_MODEL_REQUEST]: (state, action) => ({
      ...state,
      'loadingPartCarModels': true,
    }),
    [ActionTypes.GET_PART_CAR_MODEL_SUCCESS]: (state, action) => ({
      ...state,
      'partCarModels': action.response.data,
      'loadingPartCarModels': false,
    }),
    [ActionTypes.GET_PART_CAR_MODEL_FAILED]: (state, action) => ({
      ...state,
      'partCarModels': [],
      'loadingPartCarModels': false,
    }),
    [ActionTypes.CHANGE_UNREGISTERED_SUBSTITUTE_VALUE]: (state, action) => ({
      ...state,
      'unregisteredSubstitute': action.payload,
    }),
    [ActionTypes.GET_PART_REJECTION_INFO_REQUEST]: (state, action) => ({
      ...state,
      'loadingRejection': true,
    }),
    [ActionTypes.GET_PART_REJECTION_INFO_SUCCESS]: (state, action) => ({
      ...state,
      ...action.response.data,
      'loadingRejection': false,
    }),
    [ActionTypes.GET_PART_REJECTION_INFO_FAILED]: (state, action) => ({
      ...state,
      'rejectionCode': '',
      'unregisteredSubstitute': '',
      'loadingRejection': false,
    }),
    [ActionTypes.SAVE_PART_IMAGE_REQUEST]: (state, action) => ({
      ...state,
      'loadingImage': true,
    }),
    [ActionTypes.SAVE_PART_IMAGE_SUCCESS]: (state, action) => ({
      ...state,
      'loadingImage': false,
      'values': {...state.values, 'image': action.response.data},
    }),
    [ActionTypes.SAVE_PART_IMAGE_FAILED]: (state, action) => ({
      ...state,
      'loadingImage': false,
    }),
    [ActionTypes.GET_PART_VERIFICATION_REQUEST]: (state, action) => ({
      ...state,
      'verifying': true,
    }),
    [ActionTypes.GET_PART_VERIFICATION_SUCCESS]: (state, action) => ({
      ...state,
      'verifying': false,
      'isValidPart': action.response.data,
    }),
    [ActionTypes.GET_PART_VERIFICATION_FAILED]: (state, action) => ({
      ...state,
      'verifying': false,
      'isValidPart': false,
    }),
    [ActionTypes.TOGGLE_PART_FORM_CONFIRMATION]: (state, action) => ({
      ...state,
      'openConfirmation': action.payload.value,
      'confirmationMessages': action.payload.messages,
    }),
    [ActionTypes.UPDATE_PART_VERIFICATION_STATUS]: (state, action) => ({
      ...state,
      'isValidPart': action.payload,
    }),
    [ActionTypes.CLEAR_REPLACEMENT_SECTION_PART_QUOTES]: (state, action) => ({
      ...state,
      ...INITIAL_STATE,
    }),
    [ActionTypes.GET_FRANCHISEES_LIST_REQUEST]: (state, action) => ({
      ...state,
      'loadingFranchisees': true,
    }),
    [ActionTypes.GET_FRANCHISEES_LIST_SUCCESS]: (state, action) => ({
      ...state,
      'loadingFranchisees': false,
      'franchisees': action.response.data,
    }),
    [ActionTypes.GET_FRANCHISEES_LIST_FAILED]: (state, action) => ({
      ...state,
      'loadingFranchisees': false,
      'franchisees': [],
    }),
    [ActionTypes.UPDATING_PART_FRANCHISE]: (state, action) => ({
      ...state,
      'loadingFranchise': true,
    }),
    [ActionTypes.UPDATED_PART_FRANCHISE_SUCCESS]: (state, action) => ({
      ...state,
      'loadingFranchise': false,
    }),
    [ActionTypes.UPDATED_PART_FRANCHISE_FAILED]: (state, action) => ({
      ...state,
      'loadingFranchise': false,
    }),
    [ActionTypes.GET_PART_SCC_LIST_REQUEST]: (state, action) => ({
      ...state,
      'loadingpartSScc': true,
    }),
    [ActionTypes.GET_PART_SCC_LIST_SUCCESS]: (state, action) => ({
      ...state,
      'loadingpartSScc': false,
      'partsScc': action.response.data,
    }),
    [ActionTypes.GET_PART_SCC_LIST_FAILED]: (state, action) => ({
      ...state,
      'loadingpartSScc': false,
      'partsScc': [],
    }),
    [ActionTypes.FETCHING_PART_ATTACHMENTS]: (state, action) => ({
      ...state,
      'loadingAttachments': true,
      'rawAttachments': [],
      'attachments': [],
    }),
    [ActionTypes.FETCHED_PART_ATTACHMENTS]: (state, action) => ({
      ...state,
      'loadingAttachments': false,
      'rawAttachments': action.response.data,
    }),
    [ActionTypes.FETCHED_PART_ATTACHMENTS_FAILED]: (state, action) => ({
      ...state,
      'loadingAttachments': false,
      'rawAttachments': [],
      'attachments': [],
    }),
    [ActionTypes.SAVING_PART_ATTACHMENTS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.SAVED_PART_ATTACHMENTS]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.SAVED_PART_ATTACHMENTS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.SET_PART_FILES]: (state, action) => {
      const haveFiles = action.payload.length ? 'S' : 'N';
      return {
        ...state,
        'values': {...state.values, 'haveFiles': haveFiles},
        'attachments': action.payload,
      };
    },
    [ActionTypes.UPDATE_HAVE_FILES_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.UPDATE_HAVE_FILES_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATE_HAVE_FILES_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.VALIDATE_PART_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.VALIDATE_PART_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.VALIDATE_PART_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
  })(state, action);
};
